import { render, staticRenderFns } from "./ConfigPushNotification.vue?vue&type=template&id=fd5ced58&scoped=true"
import script from "./ConfigPushNotification.vue?vue&type=script&lang=js"
export * from "./ConfigPushNotification.vue?vue&type=script&lang=js"
import style0 from "./ConfigPushNotification.vue?vue&type=style&index=0&id=fd5ced58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5ced58",
  null
  
)

export default component.exports